import React from "react";

// Components
import { QuickSearchArticleItemLarge } from "../QuickSearchArticleItem";
import Pagination from "../Pagination/Pagination";

const SeriesResult = (props) => {
    return (
        <div
            className={"tab-pane fade show " + (props.initialTab === "series" ? "active" : "")}
            id="pills-series"
            role="tabpanel"
            aria-labelledby="pills-series-tab"
        >
            {props.series?.length > 0 ? (
                <>
                    {/* Pagination */}
                    <Pagination
                        handlePageChange={props.handleChange}
                        currentPage={props.seriesPage}
                        pagination={props.pagination}
                    />

                    {/* Results */}
                    <ul className="c-quick-search__result">
                        {props.series.map((item, i) => {
                            return <QuickSearchArticleItemLarge {...item} key={i} />;
                        })}
                    </ul>
                </>
            ) : (
                <div class="no-results-container">{i18n.getString("quicksearch.nomatchingresults")}</div>
            )}
        </div>
    );
};

export default React.memo(SeriesResult);
